import { STALE_TIMES } from '@iheartjane/react-query-utils';

import { getJwt } from '@jane/shared/auth';
import type { BannerMessageSetting, Store, StoreSeo } from '@jane/shared/types';

import { janeApi } from '../api/janeApi';
import { createUseQueryHook } from '../utils/createUseQueryHook';
import { queryKeys, urls } from './stores.util';

const enableWithStoreId = (id: string | number) => !!id;

const fetchStore = async (id: string | number) => {
  return await janeApi
    .get<{ store: Store }>(urls.store(id), getJwt())
    .then((result) => result.store);
};

export const useStore = createUseQueryHook<string | number, Store>(
  fetchStore,
  queryKeys.store,
  enableWithStoreId
);

const fetchStoreSeo = async (id: string | number) => {
  return await janeApi.get<StoreSeo>(urls.seo(id), getJwt());
};

export const useStoreSeo = createUseQueryHook<string | number, StoreSeo>(
  fetchStoreSeo,
  queryKeys.seo,
  enableWithStoreId
);

const fetchStoreCommsBanner = async (id: string | number) => {
  return await janeApi.get<BannerMessageSetting>(
    urls.commsBanner(id),
    getJwt()
  );
};

export const useStoreCommsBanner = createUseQueryHook<
  string | number,
  BannerMessageSetting
>(fetchStoreCommsBanner, queryKeys.commsBanner, enableWithStoreId, {
  staleTime: STALE_TIMES.short,
});
